import React, { useState } from "react";

const LoadBtn = ({ onClick, label, style, disabled }) => {
  const [busy, setBusy] = useState(false);
  const handleClick = async () => {
    if (busy || disabled) return;
    setBusy(true);
    try { await onClick(); } finally { setBusy(false); }
  };
  return <button onClick={handleClick} disabled={busy || disabled} style={{ ...style, opacity: busy ? 0.6 : 1, position: "relative" }}>
    {busy ? <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" style={{ animation: "spin 1s linear infinite" }}><path d="M21 12a9 9 0 11-6.219-8.56" /></svg>{label}</span> : label}
  </button>;
};

export default LoadBtn;
